const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M20.48 5.024q0.8-0.8 1.824-0.352t1.024 1.504v13.376q0 0.672-0.48 1.152-2.56 2.56-6.176 2.56t-6.176-2.56q-1.504-1.472-3.52-1.6t-3.648 1.152v7.616q0 0.672-0.48 1.184t-1.152 0.48-1.184-0.48-0.512-1.184v-21.696q0-0.672 0.48-1.152 2.56-2.56 6.176-2.56t6.176 2.56q1.6 1.6 3.84 1.6t3.808-1.6z"
});

const SvgFlag = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-flag",
    viewBox: "0 0 28 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flag.8e7281a3.svg";
export { ForwardRef as ReactComponent };